// Client-side image downscale + compression. Returns a JPEG/PNG data URL.
// Keeps aspect ratio, fits within maxDim x maxDim. Falls back to the raw file
// data URL if anything goes wrong (non-image, decode error, etc.).
export function compressImage(file, { maxDim = 512, quality = 0.82 } = {}) {
  return new Promise((resolve) => {
    if (!file || !file.type?.startsWith("image/")) {
      const r = new FileReader();
      r.onload = () => resolve(r.result);
      r.onerror = () => resolve("");
      r.readAsDataURL(file);
      return;
    }
    const reader = new FileReader();
    reader.onload = () => {
      const img = new Image();
      img.onload = () => {
        try {
          let { width, height } = img;
          if (width > maxDim || height > maxDim) {
            const scale = Math.min(maxDim / width, maxDim / height);
            width = Math.round(width * scale);
            height = Math.round(height * scale);
          }
          const canvas = document.createElement("canvas");
          canvas.width = width;
          canvas.height = height;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, width, height);
          // PNG for images with transparency (logos), JPEG otherwise for size.
          const isPng = file.type === "image/png";
          resolve(canvas.toDataURL(isPng ? "image/png" : "image/jpeg", quality));
        } catch {
          resolve(reader.result);
        }
      };
      img.onerror = () => resolve(reader.result);
      img.src = reader.result;
    };
    reader.onerror = () => resolve("");
    reader.readAsDataURL(file);
  });
}
